export default "__VITE_ASSET__DD4n_Tw0__"